import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsd from '../components/shared/InnerTabsd';
import { EditIcon, UserIcon2, PlusIcon } from '../components/shared/Icons';
import OnboardingForm from '../components/onboarding/OnboardingForm';
import SitesManagement from './SitesManagement';
import UsersManagement from './UsersManagement';
import Dashboard from './Dashboard';
import SubcontractorComplete from './SubcontractorComplete';
import OnboardActive from './OnboardActive';
import UsersCompliance from './UsersCompliance';
import ActiveReplacements from './ActiveReplacements';




const TABS = [
  {
    id: 'dashboardmain',
    label: 'Dashboard',
  },
  {
    id: 'database',
    label: 'Database',
  },
  {
    id: 'onboardnewall',
    label: 'Onboarding Staff',
  },
  
];





const SNLDATABASE_INNER = [
  { id: 'userallfinalonboard', label: 'Final Activation', icon: <UserIcon2 />, component: SubcontractorComplete },
  { id: 'userallstatus', label: 'Manage Users', icon: <UserIcon2 />, component: UsersManagement },
  { id: 'userallcompliance', label: 'Users Compliance', icon: <UserIcon2 />, component: UsersCompliance },
  { id: 'sitesall', label: 'Manage Clients', icon: <UserIcon2 />, component: SitesManagement },
  
  
];



const ONBOARDNEW_INNER = [
  { id: 'onboardnew', label: 'Create New User', icon: <PlusIcon />, component: OnboardingForm },
  { id: 'onboardactive', label: 'Onboarding', icon: <EditIcon />, component: OnboardActive },
  { id: 'userallfinalonboard2', label: 'Final Activation', icon: <UserIcon2 />, component: SubcontractorComplete },
  
  
];



  const DASHBOARDSUPERVISOR_INNER = [
  { id: 'dashboadall', label: 'Main Dashboard', icon: <UserIcon2 />, component: Dashboard },
  { id: 'replacementactive', label: 'Replacement', icon: <UserIcon2 />, component: ActiveReplacements },
  
  
];

const FiltersAdminPage2 = () => {
  
  const [activeTab, setActiveTab] = useState('dashboardmain');
  const { homeAccent } = useUser();

  
  

  


  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
       {activeTab === 'dashboardmain' && <InnerTabsd tabs={DASHBOARDSUPERVISOR_INNER} defaultId="dashboardall"/>}
        {activeTab === 'database' && <InnerTabsd tabs={SNLDATABASE_INNER}  defaultId="userallfinalonboard" />}
        {activeTab === 'onboardnewall' && <InnerTabsd tabs={ONBOARDNEW_INNER} defaultId="onboardnew"/>}
        
      </div>
    </div>
  );
};



export default FiltersAdminPage2;